import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column min-h-md-450px"
}
const _hoisted_2 = { class: "d-none d-md-flex mb-4" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "d-none" }
const _hoisted_5 = {
  class: "nav nav-pills nav-pills-custom row position-relative mx-0 mb-9",
  role: "tablist"
}
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bold fs-6 mb-3" }, "General", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["aria-selected"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bold fs-6 mb-3" }, "Schedule", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded" }, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["aria-selected"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "nav-text text-gray-800 fw-bold fs-6 mb-3" }, [
  /*#__PURE__*/_createTextVNode("People"),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " & Groups")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "position-absolute z-index-1 bottom-0 w-100 h-4px bg-light rounded" }, null, -1)
const _hoisted_19 = { class: "nav nav-tabs gap-4 gap-lg-10 gap-xl-15 mb-6" }
const _hoisted_20 = {
  key: 0,
  class: "fas fa-exclamation-circle ms-2 text-danger"
}
const _hoisted_21 = {
  key: 0,
  class: "row"
}
const _hoisted_22 = { class: "col-sm-12 col-md-7" }
const _hoisted_23 = { class: "col-sm-12 col-md-5" }
const _hoisted_24 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = {
  key: 0,
  class: "col-12"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-12 col-md-8" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12 col-md-4 mb-4 mb-md-0" }
const _hoisted_31 = { class: "col-12 col-md-4 mb-4 mb-md-0" }
const _hoisted_32 = { class: "col-12 col-md-4 mb-4 mb-md-0" }
const _hoisted_33 = { class: "col-12 col-md-4" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = {
  key: 1,
  class: "row"
}
const _hoisted_36 = { class: "col-12" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-12 col-md-6" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-12 col-md-4 mb-4 mb-md-0" }
const _hoisted_41 = { class: "col-12 col-md-4 mb-4 mb-md-0" }
const _hoisted_42 = { class: "col-12 col-md-4" }
const _hoisted_43 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_44 = { class: "col-12 col-md-2" }
const _hoisted_45 = { class: "col-12 d-flex flex-column scroll h-300px" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-day fa-4x" }, null, -1)
const _hoisted_47 = {
  key: 1,
  class: "table-responsive scroll-y"
}
const _hoisted_48 = { class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("thead", { class: "border-bottom border-gray-200 fs-6 text-white fw-bold bg-light bg-opacity-75" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "When"),
    /*#__PURE__*/_createElementVNode("th", null, "Where"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1)
const _hoisted_50 = { class: "fw-6 fw-semibold text-white" }
const _hoisted_51 = { class: "fw-bold" }
const _hoisted_52 = { class: "" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 2,
  class: "row"
}
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = {
  key: 3,
  class: "row"
}
const _hoisted_58 = { class: "col-12" }
const _hoisted_59 = {
  key: 4,
  class: "d-flex justify-content-center mt-auto"
}
const _hoisted_60 = {
  key: 5,
  class: "d-flex justify-content-center mt-auto"
}
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Conflict(s) found")
], -1)
const _hoisted_63 = { class: "f2-bolder fs-5" }
const _hoisted_64 = { class: "f2-light text-muted fs-6" }
const _hoisted_65 = {
  key: 0,
  class: "badge badge-success badge-sm"
}
const _hoisted_66 = { class: "fw-normal" }
const _hoisted_67 = { class: "d-flex justify-content-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_Selector2 = _resolveComponent("Selector2")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ResourceViewer = _resolveComponent("ResourceViewer")!
  const _component_ModalBase = _resolveComponent("ModalBase")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    title: "Manage Call",
    size: "modal-xl",
    ref: "modal",
    "has-toolbar": false
  }, {
    body: _withCtx(() => [
      (!_ctx.displayCollisions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
              (_ctx.mode !== 'add')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "btn-sm ms-auto",
                    "is-loading": _ctx.isLoading,
                    onClick: _ctx.remove,
                    type: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel Call ")
                    ]),
                    _: 1
                  }, 8, ["is-loading", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                (_ctx.mode === 'add')
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'general')),
                      class: "nav-item col-4 mx-0 p-0",
                      role: "presentation"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["nav-link d-flex justify-content-center w-100 border-0 h-100", {'active': _ctx.tab === 'general'}]),
                        "data-bs-toggle": "pill",
                        "aria-selected": _ctx.tab === 'general',
                        role: "tab"
                      }, _hoisted_9, 10, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'schedule')),
                  class: "nav-item col-4 mx-0 p-0",
                  role: "presentation"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["nav-link d-flex justify-content-center w-100 border-0 h-100", {'active': _ctx.tab === 'schedule'}]),
                    "data-bs-toggle": "pill",
                    "aria-selected": _ctx.tab === 'schedule',
                    role: "tab"
                  }, _hoisted_13, 10, _hoisted_10)
                ]),
                _createElementVNode("li", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'people')),
                  class: "nav-item col-4 mx-0 p-0",
                  role: "presentation"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["nav-link d-flex justify-content-center w-100 border-0 h-100", {'active': _ctx.tab === 'people'}]),
                    "data-bs-toggle": "pill",
                    "aria-selected": _ctx.tab === 'people',
                    role: "tab"
                  }, _hoisted_17, 10, _hoisted_14)
                ]),
                _hoisted_18
              ])
            ]),
            _createElementVNode("nav", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'general', 'error': _ctx.v$.call.$dirty}]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'general'))
              }, [
                _createTextVNode(" General "),
                (_ctx.v$.call.$dirty)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.mode === 'add')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'schedule'}]),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'schedule'))
                  }, " Schedule ", 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer", {'border-bottom border-3 border-primary': _ctx.tab === 'people'}]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = 'people'))
              }, " People & Groups ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["fs-4 fw-bolder pb-3 cursor-pointer ms-auto d-none d-md-block", {'border-bottom border-3 border-primary': _ctx.tab === 'availability'}]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tab = 'availability'))
              }, " View Availability ", 2)
            ]),
            (_ctx.tab === 'general')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_InputGroup, {
                      label: "Name",
                      "is-required": true
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["form-control", {'is-invalid': _ctx.v$.call.title.$error}]),
                          type: "text",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.call.title) = $event))
                        }, null, 2), [
                          [_vModelText, _ctx.call.title]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_InputGroup, {
                      label: "Call Type",
                      "is-required": true,
                      "is-loading": _ctx.loadingStates.callTypes,
                      "action-label": "manage call types",
                      onActionClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showManageScheduleModal('calltypes'))),
                      tooltip: "Add color-coded call types to your schedule."
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Selector2, {
                          class: "",
                          modelValue: _ctx.call.callTypeId,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.call.callTypeId) = $event)),
                          options: _ctx.callTypesOptions
                        }, null, 8, ["modelValue", "options"]),
                        (_ctx.v$.call.callTypeId.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "You must select a call type."))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["is-loading"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_InputGroup, {
                      label: "Description",
                      "is-required": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          theme: "snow",
                          content: _ctx.call.description,
                          "onUpdate:content": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.call.description) = $event)),
                          contentType: "html",
                          toolbar: _ctx.toolbar
                        }, null, 8, ["content", "toolbar"])
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.mode === 'update')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_InputGroup, {
                              "is-required": true,
                              label: "When"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_el_date_picker, {
                                      class: _normalizeClass({'is-invalid': _ctx.v$.call.start.$error}),
                                      type: "date",
                                      placeholder: "Start date",
                                      format: "MM/DD/YYYY",
                                      clearable: false,
                                      modelValue: _ctx.startDate,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startDate) = $event))
                                    }, null, 8, ["class", "modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createVNode(_component_el_time_select, {
                                      start: "00:00",
                                      step: "00:15",
                                      end: "23:59",
                                      placeholder: "Start time",
                                      format: "h:mm A",
                                      modelValue: _ctx.startTime,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.startTime) = $event)),
                                      clearable: false,
                                      class: _normalizeClass(["", {'is-invalid': _ctx.v$.call.start.$error}]),
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue", "class"])
                                  ]),
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_el_time_select, {
                                      start: "00:00",
                                      step: "00:15",
                                      end: "23:59",
                                      placeholder: "End time",
                                      modelValue: _ctx.endTime,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.endTime) = $event)),
                                      clearable: false,
                                      format: "h:mm A",
                                      class: _normalizeClass(["", {'is-invalid': _ctx.v$.call.end.$error}]),
                                      autocomplete: "off"
                                    }, null, 8, ["modelValue", "class"])
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_InputGroup, {
                              label: "Space",
                              "is-required": true,
                              "is-loading": _ctx.loadingStates.venues,
                              "action-label": "manage spaces",
                              onActionClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showManageScheduleModal('venues')))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Selector2, {
                                  class: "",
                                  modelValue: _ctx.call.venueSpaceId,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.call.venueSpaceId) = $event)),
                                  options: _ctx.venueSpaceOptions
                                }, null, 8, ["modelValue", "options"]),
                                (_ctx.v$.call.venueSpaceId.$error)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "You must select a venue space."))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["is-loading"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.tab === 'schedule')
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_InputGroup, {
                          "is-required": true,
                          label: "Add one or more dates"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_el_date_picker, {
                                  class: _normalizeClass({'is-invalid': _ctx.v$.currentDateSet.start.$error}),
                                  type: "dates",
                                  placeholder: "Select dates",
                                  clearable: false,
                                  "aria-autocomplete": "none",
                                  autocomplete: "off",
                                  format: "MM/DD/YYYY",
                                  modelValue: _ctx.selectedDates,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedDates) = $event))
                                }, null, 8, ["class", "modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_el_time_picker, {
                                  "is-range": "",
                                  start: "00:00",
                                  step: "00:15",
                                  end: "23:59",
                                  placeholder: "Select time range",
                                  format: "h:mm A",
                                  modelValue: _ctx.selectedTimeRange,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedTimeRange) = $event)),
                                  clearable: false,
                                  autocomplete: "off",
                                  class: _normalizeClass({'is-invalid': _ctx.v$.currentDateSet.start.$error || _ctx.v$.currentDateSet.end.$error})
                                }, null, 8, ["modelValue", "class"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_InputGroup, {
                          label: "Space",
                          "is-required": true,
                          "is-loading": _ctx.loadingStates.venues,
                          "action-label": "manage spaces",
                          onActionClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showManageScheduleModal('venues')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Selector2, {
                              class: "",
                              modelValue: _ctx.currentDateSet.venueSpaceId,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentDateSet.venueSpaceId) = $event)),
                              options: _ctx.venueSpaceOptions
                            }, null, 8, ["modelValue", "options"]),
                            (_ctx.v$.currentDateSet.venueSpaceId.$error)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "You must select a venue space."))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["is-loading"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_InputGroup, { label: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              onClick: _ctx.addDateSet,
                              type: "",
                              class: "btn-outline btn-outline-primary text-white"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Add Day/Time ")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    (_ctx.dateSet.length === 0)
                      ? (_openBlock(), _createBlock(_component_el_empty, {
                          key: 0,
                          description: "Add one or more dates to duplicate for this call."
                        }, {
                          image: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("table", _hoisted_48, [
                            _hoisted_49,
                            _createElementVNode("tbody", _hoisted_50, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDateSet, (date, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: date }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.getFriendlyCombinationDate(date.start, date.end)), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.getVenueSpaceName(date.venueSpaceId)), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", {
                                      onClick: ($event: any) => (_ctx.removeDateSet(index)),
                                      class: "link-danger btn-link cursor-pointer fw-normal"
                                    }, " remove ", 8, _hoisted_53)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tab === 'people')
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_InputGroup, {
                      label: "People",
                      "is-loading": _ctx.loadingStates.people
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.call.people,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.call.people) = $event)),
                          options: _ctx.peopleOptions,
                          mode: "tags",
                          searchable: true,
                          trackBy: "label"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    }, 8, ["is-loading"])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_InputGroup, {
                      label: "Groups",
                      "is-loading": _ctx.loadingStates.groups
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.call.groups,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.call.groups) = $event)),
                          options: _ctx.groupsOptions,
                          mode: "tags",
                          searchable: true,
                          trackBy: "label"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    }, 8, ["is-loading"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.tab === 'availability')
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_ResourceViewer)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.mode === 'add')
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.toggleClosed,
                    type: "secondary",
                    class: "btn-sm me-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.tab === 'general')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.tab = 'schedule'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Next")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.tab === 'schedule')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        type: "secondary",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.tab = 'general')),
                        class: "me-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Previous ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.tab === 'schedule')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.tab = 'people'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Next")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.tab === 'people')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 3,
                        type: "secondary",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.tab = 'schedule')),
                        class: "me-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Previous ")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.tab === 'people')
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 4,
                        "is-disabled": _ctx.v$.dateSet.$invalid,
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.commit(true, false)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Add Call ")
                        ]),
                        _: 1
                      }, 8, ["is-disabled"]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _ctx.isLoading]
                ])
              : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createVNode(_component_Button, {
                    onClick: _ctx.toggleClosed,
                    type: "secondary",
                    class: "btn-sm me-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cancel")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.commit(false, false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Save Changes")
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, _ctx.isLoading]
                ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.displayCollisions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collisions, (collision) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex flex-column pb-4",
                  key: collision.entityId
                }, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("strong", null, _toDisplayString(collision.fullName) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(collision.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createTextVNode(_toDisplayString(_ctx.getFriendlyCollisionDate(collision)) + " ", 1),
                    (collision.isFlexible)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Is Flexible"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_66, _toDisplayString(collision.comment), 1)
                ]))
              }), 128))
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createVNode(_component_Button, {
                onClick: _ctx.hideCollisions,
                type: "secondary",
                "is-loading": _ctx.isLoading,
                class: "me-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Go Back & Make Changes ")
                ]),
                _: 1
              }, 8, ["onClick", "is-loading"]),
              (_ctx.mode === 'add')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.commit(true, true))),
                    "is-loading": _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Add Call Anyway ")
                    ]),
                    _: 1
                  }, 8, ["is-loading"]))
                : _createCommentVNode("", true),
              (_ctx.mode === 'update')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.commit(false, true))),
                    "is-loading": _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Update Call Anyway ")
                    ]),
                    _: 1
                  }, 8, ["is-loading"]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.isLoading]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}